'use client';

import { useEffect } from 'react';

import { Loader } from '@polyai/ui/components/atoms/Loader';

const PARAM_WHITELIST = [
  'code',
  'state',
  'connection_id',
  'provider',
  'project_id',
];

const PARAGON_OAUTH_URL = (params: URLSearchParams) =>
  `https://passport.useparagon.com/oauth?${params.toString()}`;

const ParagonOAuthRedirect = () => {
  useEffect(() => {
    // Get all query parameters from the current URL
    const params = new URLSearchParams(window.location.search);

    // Filter query parameters based on the whitelist
    const filteredParams = new URLSearchParams();
    PARAM_WHITELIST.forEach(key => {
      const value = params.get(key);
      if (value !== null) {
        filteredParams.set(key, value);
      }
    });

    // Redirect to Paragon's OAuth endpoint with filtered query parameters
    const paragonOAuthUrl = PARAGON_OAUTH_URL(filteredParams);

    window.location.href = paragonOAuthUrl;
  }, []);

  return <Loader inProjectPage={false} fullScreen logo />;
};

export default ParagonOAuthRedirect;
